var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_vm._v("\n        กำลังเชื่อมต่อกับ LINE OA (Connecting to LINE OA)\n      ")]),_vm._v(" "),_c('v-col',{attrs:{"cols":"12"}},[_vm._v("\n        กรุณารอสักครู่ (Please wait a moment)\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55ae26c9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OhRich/UpdateNotiLinaOA.vue
// module id = null
// module chunks = 